// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__kXlYa","container":"Footer_container__R7sXj","column":"Footer_column__iAwVm","heading":"Footer_heading__0CJ+E","bottomRow":"Footer_bottomRow__Vcgqy"};